import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { productApi, dividendApi } from '../../services/privateFundApi';
import './DividendForm.css';

/**
 * 分红表单页面
 */
const DividendForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [formData, setFormData] = useState({
    dividendTime: new Date().toISOString().split('T')[0],
    sharesAfterDividend: '',
    note: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await productApi.getProductById(id);
      if (response.success) {
        setProduct(response.data);
        // 默认使用当前申购份额
        if (response.data.purchaseShares) {
          setFormData(prev => ({
            ...prev,
            sharesAfterDividend: response.data.purchaseShares.toString()
          }));
        }
      } else {
        setError(response.message || '获取产品失败');
      }
    } catch (err) {
      console.error('获取产品失败:', err);
      setError(err.message || '获取产品失败');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError(null);

      const response = await dividendApi.createDividend(id, {
        dividendTime: formData.dividendTime,
        sharesAfterDividend: parseFloat(formData.sharesAfterDividend),
        note: formData.note.trim()
      });

      if (response.success) {
        navigate(`/private-fund/products/${id}`);
      } else {
        setError(response.message || '记录分红失败');
      }
    } catch (err) {
      console.error('记录分红失败:', err);
      setError(err.message || '记录分红失败');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/private-fund/products/${id}`);
  };

  if (loading) {
    return (
      <div className="dividend-form">
        <div className="loading-message">
          <p>加载中...</p>
        </div>
      </div>
    );
  }

  if (error && !product) {
    return (
      <div className="dividend-form">
        <div className="error-message">
          <p>错误: {error}</p>
          <button onClick={handleCancel}>返回</button>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="dividend-form">
        <div className="error-message">
          <p>产品不存在</p>
          <button onClick={handleCancel}>返回</button>
        </div>
      </div>
    );
  }

  return (
    <div className="dividend-form">
      <div className="form-header">
        <button className="back-button" onClick={handleCancel}>
          ← 返回
        </button>
        <h1 className="form-title">记录分红</h1>
      </div>

      <div className="form-content">
        <div className="product-info-card">
          <h3>{product.name}</h3>
          <div className="info-row">
            <span>当前申购份额:</span>
            <span>{product.purchaseShares?.toLocaleString() || 0}</span>
          </div>
        </div>

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="dividendTime">分红时间 *</label>
            <input
              type="date"
              id="dividendTime"
              name="dividendTime"
              value={formData.dividendTime}
              onChange={handleChange}
              required
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="sharesAfterDividend">分红后份额 *</label>
            <input
              type="number"
              id="sharesAfterDividend"
              name="sharesAfterDividend"
              value={formData.sharesAfterDividend}
              onChange={handleChange}
              required
              min="0"
              step="0.01"
              placeholder="请输入分红后份额"
            />
            <p className="hint">分红模式：再投资（自动更新产品申购份额）</p>
          </div>

          <div className="form-group">
            <label htmlFor="note">分红说明</label>
            <textarea
              id="note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              rows="4"
              placeholder="可选：记录分红说明"
            />
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-button" onClick={handleCancel}>
              取消
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? '保存中...' : '确认分红'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DividendForm;

